// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
window.OnLoadSearchPopover = Backbone.View.extend({
  events: {
    "click .js-NavSearch-bootstrapPopover-tryItOut": "tryItOut",
    "click .js-NavSearch-bootstrapPopover-notNow": "notNow",
  },

  initialize: function(options) {
    Aedu.Dismissibles.recordShow("PaperSearchPopover");
    this.popoverContainer = options.popoverContainer;
    this.hideOnExternalClick();
  },

  hideOnExternalClick: function() {
    $("body").on("click", function(event) {
      if ($(event.target).closest(".js-NavSearch-bootstrapPopover").length === 0) {
        $(".js-NavSearch-bootstrapPopover").popover("hide");
      }
    });
  },

  tryItOut: function() {
    this.hide();
    this.popoverContainer.focus();
  },

  notNow: function() {
    this.hide();
    Aedu.Dismissibles.recordDismissal("PaperSearchPopover");
  },

  hide: function() {
    this.popoverContainer.popover("hide");
  },
});
